// Amounts are integers in halalas (1 SAR = 100 halalas) so no float drifts into an invoice.

export const DEFAULT_SERVICE_FEE_RATE = 0.05; // added on top of the valuer's fee
export const DEFAULT_COMMISSION_RATE = 0.005; // of the accepted offer (first year's rent for rentals)

export const toSar = (halalas: number): number => halalas / 100;

export function serviceFee(feeHalalas: number, rate = DEFAULT_SERVICE_FEE_RATE): number {
  return Math.round(feeHalalas * rate);
}

export function evaluationTotal(feeHalalas: number, rate = DEFAULT_SERVICE_FEE_RATE) {
  const service = serviceFee(feeHalalas, rate);
  return { fee: feeHalalas, service, total: feeHalalas + service };
}

/** Commission owed by the broker once an offer is accepted. */
export function commission(offerHalalas: number, rate = DEFAULT_COMMISSION_RATE): number {
  return Math.round(offerHalalas * rate);
}

export function formatSar(halalas: number, locale: 'ar' | 'en' = 'ar'): string {
  const n = toSar(halalas);
  const digits = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(n);
  return locale === 'ar' ? `${digits} ريال` : `SAR ${digits}`;
}
